import { Organization } from "../../../model";
import { User } from "../../../model/User/User";
import { apiService } from "../../ApiService";

export const getUserInfo = () => {
  return apiService.get<{ user: User; organization: Organization }>({
    path: `public/user`,
    crm: true,
    requiresAuthPolicy: "user",
  });
};
